import { Text } from "./Text.mjs";
import { ThemeOverride, useTheme } from "./ThemeProvider.mjs";
import { Flex } from "./Flex.mjs";
import { useStyles } from "purse-styles";
import React from "react";
import { Tooltip, TooltipTrigger } from "react-aria-components";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/Tooltip.tsx
const WithTooltip = ({ children, content, placement = "top" }) => {
	const theme = useTheme();
	return /* @__PURE__ */ jsxs(TooltipTrigger, {
		delay: 500,
		closeDelay: 0,
		children: [children, /* @__PURE__ */ jsx(Tooltip, {
			placement,
			offset: 8,
			className: useStyles({
				transition: `opacity ${theme.transitions.fast.duration}ms ${theme.transitions.fast.easing}`,
				"&[data-entering]": { opacity: 0 },
				"&[data-exiting]": { opacity: 0 },
				"@media (prefers-reduced-motion: reduce)": { transition: "none" }
			}),
			children: /* @__PURE__ */ jsx(ThemeOverride, {
				mode: "flip",
				children: /* @__PURE__ */ jsx(Flex, {
					background: "sand3",
					padding: "xs",
					borderRadius: "md",
					shadow: "subtle",
					style: {
						maxWidth: "250px",
						wordWrap: "break-word"
					},
					children: typeof content === "string" ? /* @__PURE__ */ jsx(Text, {
						size: "sm",
						color: "sand12",
						children: content
					}) : content
				})
			})
		})]
	});
};

//#endregion
export { WithTooltip };